import { Field } from 'react-final-form';
import { DropdownSelect, FormField, FormHelp, Label } from '@zillow/constellation-10';
import { ALL_US_STATES_AND_TERRITORIES_MAP } from '@zg-rentals/states-territories';
import { FieldValidator } from '../../../validation/validation';
import { CURRENT_STATE } from '../../../constants/formFieldNames';

export default function StateField() {
  const dropdownOptions = Object.entries(ALL_US_STATES_AND_TERRITORIES_MAP).map(([value, label]) => ({
    value,
    label,
  }));

  return (
    <Field
      name={CURRENT_STATE}
      render={({ input, meta }) => {
        const { value, onChange } = input;
        const { touched, active, error } = meta;
        const isInvalid = touched && !active && Boolean(error);

        return (
          <FormField
            {...input}
            error={isInvalid}
            label={<Label>State</Label>}
            control={
              <DropdownSelect
                value={value}
                onChange={onChange}
                placeholder="Select a state"
                options={dropdownOptions}
              />
            }
            description={isInvalid && <FormHelp>{error}</FormHelp>}
          />
        );
      }}
      validate={(state) => {
        const errors = new FieldValidator(state).required('Select a state').isStateOrTerritory().build();

        return errors ? errors : null;
      }}
    />
  );
}
